import React, { Component } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Modal } from "react-bootstrap";
//import { invokeCreateProgramFolder } from "../../utils/AwsInvoke";
import "../../css/modal/ModalExerciseNotes.css";


export default class ModalExerciseNotes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showModalSimple: false,
            folder_name: ""
        };
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            folder_name: "",
        });
    }

    handleFolderNameChange (event) {
        var folder_name = event.target.value;

        this.setState({
            folder_name: folder_name
        });
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
        }
    }

    createMarkup(text) { return {__html: text}; };

    render() {
        var notes = this.props.notes;

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
                style={{position:"relative", top:40}}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26p" style={{fontSize: 22}}>
                        <FontAwesomeIcon icon="edit" />
                    &nbsp; Trainer Notes
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <span style={{fontSize:18}}>
                      <b>{ this.props.exercise_name }</b>
                  </span>
                  <br/><br/>

                  <div className="modalFormLabelBody">
                      <div dangerouslySetInnerHTML={this.createMarkup(this.props.notes)} />
                  </div>
                          <br/>
                </Modal.Body>
                <Modal.Footer>
                  <Button onClick={this.props.onHide}>Close</Button>

                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalExerciseNotes.js